import React from 'react';

const Blog = () => {
    return (
        <div>
            <section className="dark:bg-gray-800 dark:text-gray-100 my-24">
                <div className="container flex flex-col justify-center p-4 mx-auto md:p-8">
                    
                    <h2 className="mb-12 text-4xl font-bold leading-none text-center sm:text-5xl"> Questions & Answers</h2>
                    <div className="flex flex-col divide-y sm:px-8 lg:px-12 xl:px-32 divide-gray-700">
                        <details>
                            <summary className="py-2 outline-none cursor-pointer focus:underline font-bold">1.What is the purpose of react router?</summary>
                            <div className="px-4 pb-4">
                                <p>First of all React Router is a standard library for routing or road in React  It enables the navigation among views of various components in a React Application, allows changing the browser URL, and keeps the UI in sync with the URL its benifit of without loading overall page go to diretory</p>
                            </div>
                        </details>
                        <details>
                            <summary className="py-2 outline-none cursor-pointer focus:underline font-bold">2.React context API: How it works?</summary>
                            <div className="px-4 pb-4">
                                <p>React.createContext() is all you need. It returns a consumer and a provider. Provider is a component that as it's names suggests provides the state to its children. It will hold the "store" and be the parent of all the components that might need that store</p>
                            </div>
                        </details>
                        <details>
                            <summary className="py-2 outline-none cursor-pointer focus:underline font-bold">3.How does useRef work in React?</summary>
                            <div className="px-4 pb-4 space-y-2">
                                <p>useRef returns a mutable ref object whose .current property is initialized to the passed argument ( initialValue ). The returned object will persist for the full lifetime of the component. Essentially, useRef is like a “box” that can hold a mutable value in its .current property</p>
                            </div>
                        </details>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Blog;